import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deletePoQuery = (data) => {
    return axios.delete(`${apiurl?.deletePo}?purchaseOrderId=${data?.id}&reason=${data?.reason}`);
};

const deletePo = () => {
    const queryClient = useQueryClient();
    return useMutation(deletePoQuery, {
        onSuccess: () => {
            queryClient.invalidateQueries('getPOList');
        }
    });
};

export default deletePo;
